// extracted by mini-css-extract-plugin
module.exports = {"label":"checkbox_label__z7EXd","checkbox":"checkbox_checkbox__Ft12K"};